import { faPlus, faLock, faLockOpen, faLocationArrow, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import * as _ from 'lodash'

import { Container, ContainerDataStore } from '@skinsoft/entity';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import Component from 'vue-class-component';
import {
    ADD_ITEM_TOPIC,
    CLOSE_CONTAINER_TOPIC,
    CREATE_CONTAINER_TOPIC,
    OPEN_CONTAINER_TOPIC,
    ADD_ACCESSORY_TOPIC,
    ADD_CONTAINER_TOPIC,
    ADD_LOCATION_TOPIC,
    DELETE_CONTAINER_TOPIC
} from '../../../../busTopics';
import { Routes } from '../../../../router';

require('./action-menu-container.scss')

@Component({
    props: ['entityDataStore'],
    template: require('./action-menu-container.html'),
})
export class ActionMenuContainer extends ReactiveVue {
    private plusIcon = faPlus;
    private lockIcon = faLock;
    private lockOpenIcon = faLockOpen;
    private locationIcon = faLocationArrow;
    public checkIcon = faCheck
    public crossIcon = faTimes

    private entityDataStore: ContainerDataStore;
    private entity: Container;

    private canAddItem = false;
    private canCreateContainer = false;
    private canCloseContainer = false;
    private canOpenContainer = false;
    private missingLocation = false
    private displayDeleteConfirmation: boolean = false

    private created() {
        this.subscribeToEntity();
    }

    private subscribeToEntity() {
        if (this.$route.name === Routes.CONTAINER) {
            this.subscribeTo(
                this.entityDataStore.fetchOne(this.$route.params.id),
                entity => {
                    this.missingLocation = !entity.locationItemSchema?.realTimeLocation
                    this.canOpenContainer = !entity.containerItemSchema.openContainer
                    this.canCloseContainer = !this.canOpenContainer
                    this.canAddItem = entity.containerItemSchema.openContainer
                    this.entity = entity
                },
                'entity',
            );
        } else {
            this.canCreateContainer = true
        }
    }

    private addItem() {
        this.emitOnBus(ADD_ITEM_TOPIC)
        this.$emit('toggle')
    }

    private addAccessory() {
        this.emitOnBus(ADD_ACCESSORY_TOPIC)
        this.$emit('toggle')
    }

    private addContainer() {
        this.emitOnBus(ADD_CONTAINER_TOPIC)
        this.$emit('toggle')
    }

    private createContainer() {
        this.emitOnBus(CREATE_CONTAINER_TOPIC)
        this.$emit('toggle')
    }

    private closeContainer() {
        this.emitOnBus(CLOSE_CONTAINER_TOPIC)
        this.$emit('toggle')
    }

    private openContainer() {
        this.emitOnBus(OPEN_CONTAINER_TOPIC)
        this.$emit('toggle')
    }

    private addLocation() {
        this.emitOnBus(ADD_LOCATION_TOPIC)
        this.$emit('toggle')
    }

    public deleteContainer() {
        this.emitOnBus(DELETE_CONTAINER_TOPIC)
        this.$emit('toggle')
    }

    private showDeleteConfirmation(value: boolean) {
        this.displayDeleteConfirmation = value
    }
}
